
export const calculator = ( companyType, revenue, employee, amountEmployee, productivity
) => {
  switch (companyType){
    case "Tjänsteföretag":
    case "Offentlig verksamhet":
    case "Serviceföretag":
      return (revenue * productivity * amountEmployee * employee) / employee

    case "Industriföretag": 
      return (revenue * 0.5 * productivity * amountEmployee * employee) / employee
    case "Handelsföretag":
      return (revenue * 0.25 * productivity * amountEmployee * employee) / employee
    default: 
      return null;
  }
};

export const addSpaceSeparator = value =>
  String(value)
    .replace(/ /g,'')
    .replace(/\B(?=(\d{3})+(?!\d))/g, " ");


export const hasValue = value =>
  value !== null && value !== undefined && value !== "";


export const getCompanyInformation = (companyType) => {
  switch (companyType){
    case "Tjänsteföretag":
      return 'I ett Tjänsteföretag beräknas ökad produktivitet på hela omsättningen. Vinst uppnås när försäljningen ökar med oförändrade resurser.';

    case "Offentlig verksamhet":
      return 'I Offentlig verksamhet beräknas ökad produktivitet på hela intäkten, dvs. skatter och avgifter. En produktivitetsvinst uppstår när verksamheten ökar med oförändrade anslag.';

    case "Serviceföretag":
      return 'I ett Serviceföretag beräknas ökad produktivitet på hela omsättningen. Vinst uppnås när försäljningen ökar med oförändrade resurser.';

    case "Industriföretag": 
      return 'I ett Industriföretag beräknas produktivitetsvinsten på halva omsättningen, eftersom ökad produktion innebär att kostnaderna stiger för inköp av komponenter. Vinst uppnås när försäljningen ökar med oförändrade resurser.';
    case "Handelsföretag":
      return 'I ett Handelsföretag beräknas produktivitetsvinsten på 25% av omsättningen, eftersom ökningen innebär högre kostnader för inköp av varor. Vinst uppnås när försäljningen ökar med oförändrade resurser.';
    default: 
      return null;
  }
}
